// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"2944656e","445":"a51e664b","536":"08cbc599","763":"ab6127c5","798":"1ea8e4e8","827":"295b5e6f","994":"834dcbb3"}[chunkId] + ".chunk.css";
};